import { configureStore } from '@reduxjs/toolkit'
import jobs from './slices/jobs'
import { jobsApi } from '../services/jobsApi'
import { swarmsApi } from '../services/swarmsApi'
import {creditCardsApi} from '../services/creditCards'
import { autoBuyApi } from '../services/autoBuyApi'
import { apiSlice } from '../app/api/apiSlice'
import authReducer from '../features/auth/authSlice'
import { whiteListAccountsSlice } from './slices/accounts/whiteListAccounts';
import { configsApi } from './../services/configApi';
import resourcesSlice from './slices/resources/index';
import accounts from './slices/accounts/accounts';
import buyingEmails from './slices/buyingEmails/buyingEmails';
import userTypesSlice  from './slices/accounts/userTypes';
import platforms from './slices/platforms/platforms';
import swarmsSlice from './slices/swarms/index';
import creditCards from './slices/creditCards/creditCards';
import buyManagersReducer from './slices/buyManager/buyManagers';
import strategyTypesReducer from './slices/strategyType/strategyTypes'
import swarmInActionReducer from './slices/swarmsInAction'
import swarmsForBeeReducer from '../screens/Swarms/store/index';

export const store = configureStore({
  reducer: {
    jobs,
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    [jobsApi.reducerPath]: jobsApi.reducer,
    whiteListAccountsSlice: whiteListAccountsSlice.reducer ,
    [configsApi.reducerPath]: configsApi.reducer,
    resourcesSlice,
    userTypesSlice,
    accounts,
    buyingEmails,
    platforms,
    [swarmsApi.reducerPath]: swarmsApi.reducer,
    swarmsSlice,
    creditCards,
    [creditCardsApi.reducerPath]: creditCardsApi.reducer,
    [autoBuyApi.reducerPath]: autoBuyApi.reducer,
    buyManagersSlice: buyManagersReducer,
    strategyTypesSlice: strategyTypesReducer,
    swarmsInAction: swarmInActionReducer,
    swarmsForBee: swarmsForBeeReducer,
  },

  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(
      apiSlice.middleware
    ),
  devTools: true // set false in production
})
